<template>
  <div>
    <slot :page="page"></slot>
    <el-pagination
      background
      hide-on-single-page
      layout="prev, pager, next"
      :class="controlsClass"
      :page-size="pageSize"
      :total="fullData.length"
      :current-page.sync="currentPage">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    props: {
      fullData: {
        type: Array,
        required: true
      },

      pageSize: {
        type: Number,
        default: 10
      },

      controlsClass: String
    },

    data() {
      return {
        currentPage: 1
      }
    },

    computed: {
      page() {
        const start = (this.currentPage - 1) * this.pageSize
        const end = (this.currentPage - 1) * this.pageSize + this.pageSize

        return this.fullData.slice(start, end)
      }
    },

    watch: {
      fullData() {
        this.currentPage = 1
      }
    }
  }
</script>
